import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledSelfPlanWrapper = styled(FlexContainer)`
    width: 100%;
    flex-direction: column;

    .ant-collapse + .ant-collapse {
        margin-top: 20px;
    }
`;
